import React, { useContext, useState } from "react";
import { Modal, Box, Typography, IconButton, Divider } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import "./PrivacyPolicyModalStyle.css";
import { Context } from "../../../LocalWrapper";
import { useTranslation } from "react-i18next";

const PrivacyPolicyModal = ({ pp_title }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  const context = useContext(Context);
  const { t } = useTranslation();
  const policy = t("pp_model_data", { returnObjects: true });

  return (
    <div dir={context.dir}>
      <div variant="contained" className="ppm-btn" onClick={handleOpen}>
        {t(pp_title)}
        {/* {t({"about_privacy_policy_header"})} */}
      </div>

      <Modal
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="privacy-modal"
        dir={context.dir}
        className="main-container"
      >
        <Box className="modal-container">
          <div className="modal-header">
            <Typography variant="h6" className="modal-title">
              {policy.title}
            </Typography>
            <IconButton
              size="small"
              className="close-button"
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>
          </div>

          <Divider />

          <div className="pp-modal-content">
            {policy.sections.map((section, index) => (
              <div key={index} className="section">
                <Typography variant="subtitle1" className="section-title">
                  {section.title}
                </Typography>
                {section.content.split("\n").map((line, idx) => (
                  <Typography
                    key={idx}
                    variant="body2"
                    className="section-text"
                  >
                    {/* {section.content} */}
                    {line.trim()}
                  </Typography>
                ))}
                {section.list && (
                  <ul className="pp-section-list">
                    {section.list.map((item, idx) => (
                      <li key={idx} className="pp-list-item">
                        <Typography variant="body2">{item}</Typography>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>

          <Divider />

          <div className="modal-footer">
            <button
              variant="contained"
              className="accept-button oz-btn"
              onClick={handleClose}
            >
              {t("cookies_acceptBtn")}
            </button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default PrivacyPolicyModal;
